import React, { useState, useEffect } from 'react';
import { useRef } from 'react';
import { createUseStyles } from 'react-jss';
import { ReactComponent as CloseIcon } from '../../assets/icons/CloseIcon.svg';
import TransitionText from '../common/TransitionText';
import variables from '../../theme/variables';

const useStyles = createUseStyles(
    {
        wrap: {
            position: 'fixed',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            background: 'rgba(21, 21, 21, 0.88)',
            transition: 'background 0.5s ease-in-out',
            zIndex: 7,
            transform: 'translateZ(2000px) scale(0.7145)', //'translateZ(2000px) scale(0.75)',
        },

        column: {
            position: 'absolute',
            bottom: 32,
            left: 16,
            width: 'calc(100% - 32px)',

            '@media (min-width: 768px)': {
                right: 0,
                top: 0,
                bottom: 'auto',
                left: 'auto',
                width: '50%',
                minHeight: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                padding: 50,
            },
        },

        content: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            maxWidth: 400,
        },

        closeBtn: {
            position: 'fixed',
            zIndex: 100,
            top: variables.msftHeaderHeightMobile + 100,
            right: 45,
            width: 20,
            height: 20,

            '@media (min-width: 768px)': {
                position: 'absolute',
                top: -50,
                right: 0,
                width: 25,
                height: 25,
            },
        },

        tapeNo: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: '"Segoe UI", sans-serif',
            marginBottom: 16,

            '@media (min-width: 768px)': {
                fontSize: 18,
            },
        },

        title: {
            transition: 'all 0.2s ease-in-out',
            letterSpacing: '-0.5px',
            fontWeight: 400,
            fontFamily: '"Segoe UI", sans-serif',
            margin: 0,
            fontSize: 24,
            lineHeight: '30px',
            marginBottom: 16,

            '@media (min-width: 768px)': {
                fontSize: 32,
                lineHeight: '40px',
            },
        },

        copy: {
            fontSize: 16,
            lineHeight: '22px',

            '@media (min-width: 768px)': {
                fontSize: 18,
                lineHeight: '28px',
            },
        },
    },
    { name: 'SelectedTape' }
);

export default function SelectedTape({ tape, onClose, onLeave }) {
    const classes = useStyles();

    const [state, setState] = useState('init'); // init, in, leave
    const title = useRef('');
    const tapeNo = useRef('');
    const description = useRef('');

    useEffect(() => {
        title.current = tape.title;
        tapeNo.current = tape.tapeNo;
        description.current = tape.description;
        setTimeout(() => setState('in'), 1);
    }, []);

    const handleClose = () => {
        setState('leave');
        onLeave();
        setTimeout(onClose, 510);
    };

    return (
        <div className={classes.wrap}>
            <div className={classes.column}>
                <div className={classes.content}>
                    <button className={classes.closeBtn} onClick={handleClose}>
                        <CloseIcon width="100%" height="100%" />
                    </button>
                    <TransitionText state={state}>
                        <h2 className={classes.tapeNo}>
                            Mixtape #{tapeNo.current}
                        </h2>
                    </TransitionText>
                    <TransitionText state={state} delay={200}>
                        <h3
                            className={classes.title}
                            dangerouslySetInnerHTML={{
                                __html: title.current,
                            }}
                        ></h3>
                    </TransitionText>
                    <TransitionText state={state} delay={400}>
                        <p
                            className={classes.description}
                            dangerouslySetInnerHTML={{
                                __html: description.current,
                            }}
                        ></p>
                    </TransitionText>
                </div>
            </div>
        </div>
    );
}
